module.exports = __webpack_public_path__ + "img/155.27ee32fb.jpg";